export const world = [
  {
    key: "kRYHqBT1ru-K-qetlWcWQ",
    pos: [8, 0, -3],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "1dd73yL2bR0eQ4SDSDzQA",
    pos: [8, 0, -2],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "ZQGG3VekuE4Lob9cP7CWc",
    pos: [8, 0, -4],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "gnZAh7fOTL2dUDkkclsiU",
    pos: [8, 0, -1],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "LPQyMHNgrqiAXiaBQpzRi",
    pos: [8, 1, -1],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "JZ_j5ttra3dc8j_kHsnZJ",
    pos: [8, 2, -1],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "n9qFpMJYUQ43kOzUKzMAB",
    pos: [8, 3, -1],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "qNjufz5te-Pp8LT1eqxUU",
    pos: [8, 4, -1],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "8RX_y--jjkbamYLT9w9IR",
    pos: [8, 4, -2],
    texture: "obsidian",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "1cZityEPzUr4v2wEei4Xl",
    pos: [8, 4, -3],
    texture: "obsidian",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "kuYBQPR4tYOn4RS7w4htb",
    pos: [8, 4, -4],
    texture: "obsidian",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "5Cv-IZ6MiHWdvd_WQ2PPl",
    pos: [8, 3, -4],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "GlXHDfeXzSv-kaIjpJJfS",
    pos: [8, 2, -4],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "03-VBuU6ogrvRE2qgQ98k",
    pos: [8, 1, -4],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "tEwKJ21eZhIyLWYiu61EY",
    pos: [7, 0, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "Hjl83s6y3uGvVI4_ab0vh",
    pos: [7, 1, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "fs_5tv483IOYJfZOiZHgo",
    pos: [7, 2, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "nj7-knDaKbliHqi22yu-R",
    pos: [7, 4, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "o1Ttus-ec6-53-EHkCM7K",
    pos: [6, 0, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "GhX6YXV7DT86qsTk8uysW",
    pos: [6, 2, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Dzs5I1ABH8YKTS_qO9IVd",
    pos: [5, 1, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "EAALMKlpx-WcCXcRjmCgj",
    pos: [5, 0, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "m6jhu8sj9ygzfW2Aa502K",
    pos: [6, 0, -15],
    texture: "moss",
    rotation: [0, 0, 0],
  },
  {
    key: "8t_HD2K8MJ2ZEHWb7i9gv",
    pos: [2, 0, -15],
    texture: "moss",
    rotation: [0, 0, 0],
  },
  {
    key: "fbsV8Its3EWQGScbfKYLp",
    pos: [4, 0, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "94GEF_IUsj_g2G5v9PEsP",
    pos: [3, 0, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "k8Qd3-lo7z-XIgTBElJWe",
    pos: [2, 0, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "HEGJGQHJ65IYYbz7gmfsA",
    pos: [2, 0, -17],
    texture: "cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "oCn3JZ2qZ2msOgnrof-Pe",
    pos: [2, 0, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "vPCFoXiFPEeHhCwp-eqhx",
    pos: [2, 0, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "q7cmKWSD1qjY04qLGUCvj",
    pos: [6, 0, -20],
    texture: "cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "1wDCWk6DJxVkYawTuVsul",
    pos: [5, 0, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "ii0A-UzKiN77FuwjCjYM0",
    pos: [3, 0, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Jds8kpUetGeyTxwCNBc-c",
    pos: [5, 0, -17],
    texture: "oak_plank",
    rotation: [0, 0, 0],
  },
  {
    key: "INSaJ_72Cg1wu6e9ymue2",
    pos: [5, 0, -18],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "wVuRXiRILdqD73I4bpXxD",
    pos: [4, 0, -17],
    texture: "oak_plank",
    rotation: [0, 0, 0],
  },
  {
    key: "wzCf_kjuYqbl5V60W9CoE",
    pos: [4, 0, -18],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "ve5gPsFJdqYBKMsrktAcJ",
    pos: [3, 0, -17],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "wH6eh-BPaH3g0g0hh8EoM",
    pos: [3, 0, -18],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "6TLHj895h4cqtO9AF_rt_",
    pos: [3, 0, -19],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "k6DMyE__5Tx3XbUjwz6cC",
    pos: [4, 0, -19],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "4DkY7nGwuZYBLRA9fN2vS",
    pos: [5, 0, -19],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "C-izyku87FFd1T_1yJynt",
    pos: [6, 3, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "XXe0flfKA0ck2KywjuDyN",
    pos: [5, 3, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "9oUYZaF49NaicygfXxh_r",
    pos: [7, 3, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "DuxOxWSMLgIC-qKck6qs2",
    pos: [1, 0, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "lexS6eLgCBGrsSd9LIOqa",
    pos: [1, 1, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "4u3VHWFuY1WDcoNmYuZd4",
    pos: [1, 2, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "f7_QBpIUrzqINYA-bBkFm",
    pos: [1, 3, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "S5ILbGmE99ifsz_LCIcKq",
    pos: [3, 1, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "V8cqr5r89RRD3o8Fppgzs",
    pos: [2, 1, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "rmatXtWMfu8dWWLmaeLZu",
    pos: [3, 2, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "u3aN5224mkXdJ5QHWIbpP",
    pos: [2, 1, -17],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "MBz8yYT2L9JWjjdrB3HF-",
    pos: [2, 1, -18],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "-2nZ44E3bi_y8q_d7BTwe",
    pos: [2, 1, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "ad9mBwJS8_qTkFXatt8kA",
    pos: [2, 1, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "-udtS8-Shzbyevlvn4xjJ",
    pos: [4, 1, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Y_dPfHIgI2W9P-zuatW6g",
    pos: [5, 1, -20],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "uKTUZf1bzM9ijlIjNAA1J",
    pos: [6, 1, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "LxnTO7_3G3OJ1uPwTOzB3",
    pos: [6, 1, -17],
    texture: "cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "_QWnf5Q87mZZVaF4Pdivh",
    pos: [6, 2, -17],
    texture: "cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "V0r3WwNDvhTXUoLmY10Xi",
    pos: [6, 3, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "513sybJZWaySzT17Sg-lU",
    pos: [6, 2, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "9u88SnfCDTSGzQEMcKZu_",
    pos: [6, 3, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "tGXoplXR4A9uP3lxM8eq0",
    pos: [6, 2, -18],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "n-ZOm3VK8mPp2cS2Yout8",
    pos: [6, 3, -18],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "ma-N-9YoW5_QkCCGIxvas",
    pos: [6, 4, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "BTxUd0rxAXtgj3wSe6eTI",
    pos: [6, 4, -17],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "gnSTqJ4b5jtVs-8mJ7GV7",
    pos: [6, 4, -18],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "UD9MKwivQB9Pijz9s-xMV",
    pos: [5, 2, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "pwIiVO2KBnFoxTl3Qgp7B",
    pos: [5, 4, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "B4JJwHswb5g4u7ExvWy6P",
    pos: [3, 2, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "8mwQDlT8sSt8D5cO-w610",
    pos: [4, 2, -20],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "bdD_pp7qaucySKVI0p_6Q",
    pos: [4, 3, -20],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "oLDaqZMTvaFJrTAh-zIKs",
    pos: [4, 4, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "UZe6npK4yH1BOpDhAchZC",
    pos: [3, 3, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Ll6XCcFe6EhgA1K8NOpIb",
    pos: [3, 4, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "GcB4BKCJTMGxoct46YSdf",
    pos: [2, 2, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "zlB-JZbpvRarX7CNQpYTA",
    pos: [2, 4, -20],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "697ZKX7s4zNO2phIbVEWN",
    pos: [2, 3, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Xit3mum_itbSafmFSeZeW",
    pos: [2, 4, -19],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "Q28Y5pVtwHJNEiJVUNtyL",
    pos: [2, 2, -18],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "Yl0qQeZdbaPIGBI1z6wss",
    pos: [2, 3, -18],
    texture: "glass",
    rotation: [0, 0, 0],
  },
  {
    key: "sAV28P1mlvrFAM0vJjVpx",
    pos: [2, 4, -18],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "56uyoQTTnt_mpqX79YBeV",
    pos: [2, 2, -17],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "0-hTRfJpmNY0nSAAC0hyH",
    pos: [2, 4, -17],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "9ep-OoUXDDUq33PbJ6dRE",
    pos: [5, 4, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "_l6jyyYjAXCBYywQFMfvn",
    pos: [3, 3, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "7XTK1BUUn_BHEZlHA8buU",
    pos: [3, 4, -16],
    texture: "cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "6diIn7iKVZBTlSB7Xn9Rm",
    pos: [4, 4, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "q7jF144zToZZhC4pQaVq1",
    pos: [2, 3, -16],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "JUhfncSks_GRnvrbI-xrB",
    pos: [2, 2, -16],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "USb8aCFQ1tKn-QkawK73u",
    pos: [4, 3, -16],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "zI1D_Vd2vGLHmn57DCHqr",
    pos: [5, 2, -16],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "HgezKcMxFisWP-WUjAfmX",
    pos: [6, 1, -16],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "bBTqdX65_FI48Bjw8HxmA",
    pos: [6, 3, -17],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "1Wf4uHBvmgFI-6Rics3qW",
    pos: [6, 1, -20],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "b2JvJ06v4kWORc6Cf_cSR",
    pos: [6, 2, -19],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "2d6-rsFjMnwPiKebD1ojm",
    pos: [6, 4, -19],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "RkkNNFejipRU39wsBL-aa",
    pos: [6, 1, -18],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "ZdEGJ8G5tIb0ryeGqMD9D",
    pos: [6, 0, -17],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "tNGW6eXx_b5S9p39pmys-",
    pos: [6, 0, -18],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "QFa4ecjnLOd5v252LHy6m",
    pos: [6, 4, -20],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "x8UQGgRtvAjJ9Q_NhRdER",
    pos: [5, 3, -20],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "hGwYKGH5xEdsDRtti-2mh",
    pos: [2, 3, -20],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "VwiOukBeDst3caZkyAMGJ",
    pos: [3, 1, -20],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "pwmzcBbWwI51zCx4kcrop",
    pos: [4, 0, -20],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "beGm40B4NDjcvXAWtl8F4",
    pos: [2, 4, -16],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "NubKE4d_diyTsvfSGTgBD",
    pos: [2, 3, -17],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 0],
  },
  {
    key: "6KshJd6fJcRGLSRQcKciU",
    pos: [2, 2, -19],
    texture: "mossy_cobblestone",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "OA6yGn2UPuKPydwXsyUUo",
    pos: [2, 0, -18],
    texture: "mossy_cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "cJn5XsC257DxQTiU51aDJ",
    pos: [1, 0, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "wi5WqbOOEl7Tb1pWZG_68",
    pos: [1, 1, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "urPeck0kxYMlTNJ8axRMx",
    pos: [1, 2, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "wZUeozq3lTb4g8rSiFxCB",
    pos: [1, 3, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "5IJ9NXccKHfbcWRnA7loe",
    pos: [1, 4, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "cCKGs2hjxziZyjAfACL9T",
    pos: [1, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "suDWTKx5S8chxWViCvGlK",
    pos: [1, 4, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "ufpOKRi2Ln6EjMabo1cV9",
    pos: [7, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "b5YeF6qHsgDusxiPWOFSG",
    pos: [6, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "_px6G8LnKkxfqduryjqRE",
    pos: [1, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "OieOaQa4SacVuD3q0AB1d",
    pos: [2, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "MdAGW0Mqvzv9CTnDd2Sqf",
    pos: [3, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "cDX-wLzdIBsIt4g5Oz1VX",
    pos: [4, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "81J4xeZxXzCTjBqz36vhp",
    pos: [5, 5, -15],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "mrl7RdA024QhJ24wLTGOs",
    pos: [1, 5, -20],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "fSIfHLOrn2QdaKX7E8Oci",
    pos: [1, 5, -19],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "0NaZ0SFKYK3vEtYwZ-cu_",
    pos: [1, 5, -18],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "3WgKNfv4HCIT7CJerd_c8",
    pos: [1, 5, -17],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "g3YLe-rv-Rg9kbOYPbRrI",
    pos: [1, 5, -16],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "WPkF5uyIzHqEIjjgU9qmv",
    pos: [2, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "TcTlsGwZhFiU32kATqJsF",
    pos: [3, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "KowVD8M3R4k32A-eTlA5_",
    pos: [4, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "BV7T2Mnu1HoEqcnwQGZpT",
    pos: [5, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "RP-91P4xTTlBVels06UTk",
    pos: [7, 5, -16],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "yfPWx9VZrtpdDa3r7eDOB",
    pos: [7, 5, -17],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "Nnw9N3RgLFTYBOql0XKKZ",
    pos: [7, 5, -18],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "z_6SVAn4ITeDilTVzqSEX",
    pos: [7, 5, -19],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "SiTe5cwEkr-Jqpg6sUyXC",
    pos: [6, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "lXQp2O-XB73ixigEtMlk4",
    pos: [7, 0, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "KbO13ijVCksI65PI4Bjka",
    pos: [7, 1, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "rVArUCp8azKCqE6JFWX1X",
    pos: [7, 2, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "Bd6681COz6qRCtDAhtgfb",
    pos: [7, 3, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "OP9tlNHRRqKXP0bpuPFrA",
    pos: [7, 4, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "XWyij_lH4h0swO6arLv8Q",
    pos: [7, 5, -21],
    texture: "oak_log",
    rotation: [0, 0, 0],
  },
  {
    key: "1ETdDtnekJMdtnRJu-WMR",
    pos: [7, 5, -20],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "7qCzlgjAMDu0diQEBewGs",
    pos: [5, 5, -16],
    texture: "oak_plank",
    rotation: [0, 0, 0],
  },
  {
    key: "OIW-zPMs7AvNo1gxDpDkV",
    pos: [6, 5, -16],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "ryA2tsEKS4_tX1bno5xJI",
    pos: [6, 5, -17],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "lJYrpbN9wcX5mwr27AuF9",
    pos: [6, 5, -18],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "S0e4jT4lUg1wlSeJK8dgm",
    pos: [5, 5, -17],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "z10MljCKL9qMFl5KM8RZs",
    pos: [5, 5, -20],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "A63OGlToPqTQ8nlcszLni",
    pos: [5, 5, -19],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "Ku12J_wywdQABmoJ1pXpX",
    pos: [5, 5, -18],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "RlCI6Neu8O0hwhEQABoFn",
    pos: [6, 5, -20],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "-ndDudjYufRjsIhqb9LoN",
    pos: [6, 5, -19],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "6jCxmUgZn0Yobg3vLzWT2",
    pos: [2, 5, -19],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "dj8_D0DnTIkeeiL8CS6U4",
    pos: [2, 5, -20],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "iiagKF4f3MyyGeVOA09Vj",
    pos: [3, 5, -20],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "_k1QhvYZPH5kz1aXXnhP6",
    pos: [3, 5, -19],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "2YP3rOkNJCEPRNraB57-q",
    pos: [2, 5, -18],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "lVRCXoMPlwSXJnbVlcj_n",
    pos: [3, 5, -18],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "-7LYC0LfZ74gXKx2FReNo",
    pos: [2, 5, -16],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "hNl0JKFxxtNBKyG9yikh-",
    pos: [2, 5, -17],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "FQZLaSNlO-osYmRpaCz5a",
    pos: [3, 5, -16],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "Dgsn-bAwfuYQ3jnV4hNeA",
    pos: [3, 5, -17],
    texture: "oak_plank",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "qS7du6h1wDJck5AkGV9Ry",
    pos: [4, 5, -16],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "QYaGBvko8MzG16JoTO1PZ",
    pos: [4, 5, -17],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "LrqHmuJlMcDv8zkrdRDbc",
    pos: [4, 5, -20],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "9sWQM1KElJ11vO59EiIoW",
    pos: [4, 5, -19],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "ZlRGrsHivgz9b2wM3zXjg",
    pos: [4, 5, -18],
    texture: "oak_log",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "4JUyBA5eyAxhQlN1ir6a4",
    pos: [5, 0, -15],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "dqL3Ehb-29kYdzPzspuTD",
    pos: [4, 0, -15],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "-RDXixZh3araXuTJnWPGy",
    pos: [3, 0, -15],
    texture: "oak_plank",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "hsMwuU0hAIQhSAsN88vh4",
    pos: [7, 0, -16],
    texture: "grass_block",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "ta469tF8WOURp2WPd5YIM",
    pos: [7, 0, -17],
    texture: "grass_block",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "nfg4yf3x3ctr24wbSx8ly",
    pos: [6, 0, -19],
    texture: "cobblestone",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "QTNOReiloQEXytVzKEl8e",
    pos: [7, 0, -18],
    texture: "grass_block",
    rotation: [1.5707963267948966, 0, 0],
  },
  {
    key: "8fUv4nqmWJs7sK1ggS2fK",
    pos: [7, 0, -19],
    texture: "grass_block",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "XbBYW5PFQHjg1IkJS7tIr",
    pos: [7, 0, -20],
    texture: "grass_block",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "8YmnbFE_1iFg2XfeAWhY2",
    pos: [2, 0, -21],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "f8M33xtHphDNTfil1fnan",
    pos: [3, 0, -21],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "MxxdeOFT5se5I2FB6vdLf",
    pos: [4, 0, -21],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "xm13DpqnoXGK5KQyg6JzK",
    pos: [5, 0, -21],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "UnoBeWcmh-rNSfiTTRkLI",
    pos: [6, 0, -21],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "nMstb5sUyOAxgfddvYDUO",
    pos: [1, 0, -16],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "fzoFiHL0aE4XECpQrp8L8",
    pos: [1, 0, -17],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "MfjGNZ5Y3zUmKurNn0wDU",
    pos: [1, 0, -18],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "0_zvAjN-OZ7C5Bop81fhw",
    pos: [1, 0, -19],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
  {
    key: "5gid4xBGQWKzFcUZx-enw",
    pos: [1, 0, -20],
    texture: "grass_block",
    rotation: [0, 0, 0],
  },
];
